export const getDepartureWindowOptions = () => {
  return [
    '06:00 am and 08:00 am',
    '06:00 am and 10:00 am',
    '06:45 am and 07:15 am',
    '07:15 am and 07:45 am',
    '07:45 am and 08:15 am',
    '08:15 am and 08:45 am',
    '08:15 am and 09:30 am',
    '08:45 am and 09:15 am',
    '09:15 am and 09:45 am',
    '09:30 am and 11:30 am',
    '10:30 am and 12:45 pm',
    '11:00 am and 11:45 am',
    '11:30 am and 12:30 pm',
    '12:00 pm and 01:00 pm',
    '12:00 pm and 02:00 pm',
    '12:00 pm and 05:00 pm',
    '01:00 pm and 02:30 pm',
    '02:40 pm and 04:30 pm',
    '02:15 pm and 03:30 pm',
    '02:00 pm and 06:00 pm',
    '4:15 pm and 6:30 pm'
  ];
};
